package com.exura.components.loading

import androidx.compose.runtime.Composable
import com.exura.components.icons.ExuraIcon
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.silk.style.CssStyleVariant
import com.varabyte.kobweb.silk.style.toModifier

@Composable
internal fun Loader(
    blockUi: Boolean = true,
    overlayVariant: CssStyleVariant<LoaderOverlayKind>? = null,
    loaderVariant: CssStyleVariant<LoaderKind>? = null,
    spinnerModifier: Modifier = Modifier,
) {
    Box(
        contentAlignment = Alignment.Center,
        modifier = LoaderOverlayStyle.toModifier(overlayVariant)
            .then(if (blockUi) Modifier.onClick { it.stopPropagation() } else Modifier)
    ) {
        Box(
            modifier = LoaderStyle.toModifier(loaderVariant)
                .then(spinnerModifier)
        ) {
            ExuraIcon(modifier = Modifier.fillMaxHeight())
        }
    }
}
